import InfoIcon from 'components/ReusableComponents/Icons/Info'

import styles from './HotelPlanTooltip.module.scss'

const SolutionTooltipSection = ({ title, features }) => (
  <div className={styles.section}>
    <p className={styles.sectionTitle}>{title}</p>
    <ul className={styles.featureList}>
      {features.map(feature => (
        <li key={feature} className={styles.featureItem}>
          {feature}
        </li>
      ))}
    </ul>
  </div>
)

const HotelPlanTooltip = ({
  solutionFeatures,
  iconOnly = false,
  iconSize = 20,
  align = 'right',
  className = ''
}) => {
  if (!solutionFeatures?.planLabel || !solutionFeatures.sections?.length) {
    return null
  }

  const wrapperClassName = [
    styles.wrapper,
    align === 'left' ? styles.alignLeft : styles.alignRight,
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={wrapperClassName}>
      <button type="button" className={styles.trigger} tabIndex={0}>
        <InfoIcon style={{ fontSize: iconSize, width: iconSize, height: iconSize }} />
        {!iconOnly && (
          <span className={styles.triggerLabel}>{solutionFeatures.planLabel}</span>
        )}
      </button>
      <div className={styles.tooltip} role="tooltip">
        <div className={styles.tooltipHeader}>
          <p className={styles.tooltipTitle}>{solutionFeatures.planLabel}</p>
          <p className={styles.tooltipSubtitle}>Available for your property</p>
        </div>
        {solutionFeatures.sections.map(section => (
          <SolutionTooltipSection
            key={section.title}
            title={section.title}
            features={section.features}
          />
        ))}
      </div>
    </div>
  )
}

export default HotelPlanTooltip
